import React from 'react';
import { Box, Typography } from '@mui/material';
import DisciplineAccessControl from '../common/DisciplineAccessControl';

const HighMastReportsPage = () => {
  return (
    <DisciplineAccessControl requiredDiscipline="Vertical Asset">
      <Box sx={{ padding: 3, maxWidth: '100%' }}>
        {/* Header */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h4" component="h1" sx={{ fontWeight: 600, mb: 0.5 }}>
            High Mast Inspection Reports
          </Typography>
          <Typography variant="body1" color="text.secondary">
            View and manage High Mast inspection reports
          </Typography>
        </Box>

        {/* Placeholder */}
        <Box sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
          gap: 3,
          mb: 3
        }}>
          {/* PDF/Excel Reports */}
          <Box
            sx={{
              p: 3,
              borderRadius: 2,
              boxShadow: '0 6px 20px rgba(0, 0, 0, 0.05)',
              border: '2px dashed',
              borderColor: 'divider',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: '300px',
              backgroundColor: 'background.paper'
            }}
          >
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Inspection Reports
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Generate PDF and Excel reports
                <br />
                for High Mast inspections with
                <br />
                defect details and annotated photos
              </Typography>
            </Box>
          </Box>

          {/* Case Status Reports */}
          <Box
            sx={{
              p: 3,
              borderRadius: 2,
              boxShadow: '0 6px 20px rgba(0, 0, 0, 0.05)',
              border: '2px dashed',
              borderColor: 'divider',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: '300px',
              backgroundColor: 'background.paper'
            }}
          >
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Case Status Reports
              </Typography>
              <Typography variant="caption" color="text.secondary">
                SLA compliance summaries,
                <br />
                overdue case listings, and
                <br />
                resolution trend analysis
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </DisciplineAccessControl>
  );
};

export default HighMastReportsPage;
